// src/components/sections/HeroSection.jsx
// Hero section with main headline and CTA

import React from 'react';
import { STATS } from '../../config/constants';
import Button from '../common/Button';
import Card from '../common/Card';

const HeroSection = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative z-10 px-6 py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          <div className="inline-block mb-8 floating-icon">
            <span className="badge">✨ TRUSTED BY 200+ HAPPY BUSINESSES</span>
          </div>

          <h1 className="text-6xl md:text-8xl font-bold mb-6 leading-tight dark:text-white">
            We Build
            <br />
            <span className="gradient-text">Epic Digital</span>
            <br />
            Experiences! 🎯
          </h1>

          <p className="text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto mb-12 leading-relaxed dark:text-gray-300">
            Stop juggling multiple agencies. We're your all-in-one digital powerhouse –
            websites, social media, growth strategies, all under one roof!
          </p>

          <div className="flex gap-6 justify-center flex-wrap">
            <Button
              variant="primary"
              size="large"
              onClick={() => scrollToSection('contact')}
            >
              Get Started Free 🎉
            </Button>
            <Button
              variant="secondary"
              size="large"
              onClick={() => scrollToSection('features')}
            >
              See Our Magic ✨
            </Button>
            <Button
              variant="secondary"
              size="large"
            >
              Clientele 💼
            </Button>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-20">
          {STATS.map((stat, index) => (
            <Card key={index} variant="default" className="text-center">
              <div className="text-4xl mb-2">{stat.emoji}</div>
              <div className="text-3xl md:text-4xl font-bold gradient-text mb-1">
                {stat.number}
              </div>
              <div className="text-gray-600 font-medium text-sm md:text-base">
                {stat.label}
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
